import PriceAdvisorReport from './PriceAdvisorReport';

export default PriceAdvisorReport;
